import { Box, Typography } from "@mui/material";


export default function PortfolioFooterSummary({
   rowCount,
   amountInvested,
}) {
  
  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        alignItems: "center",
        bgcolor: "#fff",
        borderTop: "1px solid #e5e7eb",
        px: 2,
        py: 1.5,
      }}
    >
      <Typography fontSize={13} fontWeight={600}>
        Total
      </Typography>
      <Typography fontSize={13}>
        Companies: <strong>{rowCount}</strong>
      </Typography>
      <Typography fontSize={13}>
        Invested Capital: <strong>${(amountInvested).toFixed(2)}M</strong>
      </Typography>
     {/*  <Typography fontSize={13}>
        Board Seats Held: <strong>11</strong>
      </Typography> */}
    </Box>
  );
}
